import React from 'react'

import { RIGHT_TYPE, RIGHT_TYPE_DIGITAL, RIGHT_TYPE_ONSITE, RIGHT_TYPE_OTHER, RIGHT_TYPE_POSTS } from '../../fields'
import DigitalRightEditSections from './sectionsLists/DigitalRightEditSections'
import PostsRightEditSections from './sectionsLists/PostsRightEditSections'
import OtherRightEditSections from './sectionsLists/OtherRightEditSections'
import OnsiteRightEditSections from './sectionsLists/OnsiteRightEditSections'

const RightEditFormContent = ({ formik }) => {
  const { values } = formik

  const rightType = values[RIGHT_TYPE]

  if (rightType === RIGHT_TYPE_DIGITAL) {
    return <DigitalRightEditSections formik={formik} />
  } else if (rightType === RIGHT_TYPE_POSTS) {
    return <PostsRightEditSections formik={formik} />
  } else if (rightType === RIGHT_TYPE_OTHER) {
    return <OtherRightEditSections formik={formik} />
  } else if (rightType === RIGHT_TYPE_ONSITE) {
    return <OnsiteRightEditSections formik={formik} />
  }

  return null
}

export default RightEditFormContent
